export default function MobileItemsAndPostsIcon({ svgClass, wrapperClass }) {
  return (
    <div className={wrapperClass}>
      <svg
        className={svgClass}
        width='26.477'
        height='33'
        viewBox='0 0 26.477 33'>
        <g
          id='items_and_posts_icon'
          data-name='items and posts icon'
          transform='translate(-1161 -32)'>
          <path
            id='Subtraction_7'
            data-name='Subtraction 7'
            d='M2.768,26.555h0A3.99,3.99,0,0,1,0,22.748V4A4,4,0,0,1,4,0H17.215a3.989,3.989,0,0,1,3.806,2.767H6.767a4,4,0,0,0-4,4V26.554Z'
            transform='translate(1161 32)'
            fill='#fff'
          />
          <rect
            id='Rectangle_55'
            data-name='Rectangle 55'
            width='21.039'
            height='27.801'
            rx='4'
            transform='translate(1166.438 37.199)'
            fill='#fff'
          />
        </g>
      </svg>
    </div>
  );
}
